import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import './nfdMissionSection.scss'
import { ReactComponent as Path11 } from "./components/path11.svg";
import { ReactComponent as PathAdaptive } from "./components/path111.svg";
import { ReactComponent as Planet1 } from "./components/planet1.svg";
import { ReactComponent as Planet2 } from "./components/planet2.svg";
import { gsap } from "gsap";
import MotionPathPlugin from "gsap/MotionPathPlugin";

gsap.registerPlugin(MotionPathPlugin);

const NfdMissionSection = () => {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const animationsRef = useRef<any[]>([]);
	
	const [width, setWidth] = useState(window.innerWidth);
	
	useLayoutEffect(() => {
		const block = containerRef.current;
		
		if (!block) return;
		
		const ctx = gsap.context(() => {
			
			const startAnimation = () => {
				const planet111 = document.getElementById (
					"planet111"
				) as SVGPathElement | null;
				const path1 = document.getElementById (
					"path1"
				) as SVGPathElement | null;
				const planet222 = document.getElementById (
					"planet222"
				) as SVGPathElement | null;
				const path2 = document.getElementById (
					"path2"
				) as SVGPathElement | null;
				
				if (path1 && planet111) {
					const animation = gsap.from (planet111, {
						duration: 6,
						motionPath: {
							path: "#path1",
							align: "#path1",
							alignOrigin: [0.5, 0.5],
							autoRotate: true,
						},
						opacity: 0,
						repeat: -1,
						ease: 'none',
						onUpdate: () => {
							const progress = animation.progress ();
							if (progress > 0.05 && progress < 0.75) {
								gsap.to (planet111, {opacity: 0, duration: .2});
							} else {
								gsap.to (planet111, {opacity: 1, duration: .1});
							}
							gsap.set (planet111, {rotation: "+=90"});
						},
					});
					
					animationsRef.current.push (animation);
				}
				
				if (path2 && planet222) {
					const animation = gsap.from (planet222, {
						duration: 5,
						motionPath: {
							path: "#path2",
							align: "#path2",
							alignOrigin: [0.5, 0.5],
							autoRotate: true,
						},
						opacity: 0,
						delay: 4,
						repeat: -1,
						ease: 'none',
						onUpdate: () => {
							const progress = animation.progress ();
							if (progress > 0.1 && progress < 0.8) {
								gsap.to (planet222, {opacity: 0, duration: .2});
							} else {
								gsap.to (planet222, {opacity: 1, duration: .5});
							}
							gsap.set (planet222, {rotation: "+=90"});
						},
					});
					
					animationsRef.current.push (animation);
				}
			}
			
			const stopAnimation = () => {
				animationsRef.current.forEach ((animation) => animation.kill ());
				animationsRef.current = [];
			};
			
			const observer = new IntersectionObserver (
				([entry]) => {
					if (entry.isIntersecting) {
						startAnimation ();
					} else {
						stopAnimation ();
					}
				},
				{threshold: 0.1}
			);
			
			if (block) observer.observe(block);
			
			return () => {
				observer.disconnect();
				stopAnimation();
			};
			
		}, block);
		
		return () => {
			ctx.revert(); // Уничтожаем контекст и останавливаем анимации
		};
		
	}, []);
	
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);
	
	return (
		<div className="nfdMission" ref={containerRef}>
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="nfdMission__info adaptive">
				<h2>What is NFD</h2>
			</div>
			<div className="testMain">
				{
					width > 767 ? (
						<Path11 />
					) : (
						<PathAdaptive />
					)
				}
				{
					width > 767 ? (
						<Planet1 id="planet111" className="planet" />
					) : (
						<Planet2 id="planet111" className="planet" />
					)
				}
				<Planet2 id="planet222" className="planet" />
			</div>
			<div className="nfdMission__info">
				<h2>What is NFD</h2>
				<div className="nfdMission__info_mission">
					<h3>Our Mission</h3>
				</div>
				<div className="nfdMission__info_description">
					<span>Our team has been developing products for over 3 years
						to improve user experience when interacting with crypto world.
						Also, one of our tasks is to stimulate the mass adoption
						for the rapid growth of the entire web-3 industry.
						We have extensive experience and deep understanding of most web-3
						areas and based on this experience we build our products,
						which then simplify interactions, close inefficiencies and help
						save time and make money for our users.</span>
				</div>
				<div className="nfdMission__info_button">
					<button className="mainButton">
						<span>Learn more</span>
					</button>
				</div>
			</div>
		</div>
	);
};

export default NfdMissionSection;